import { render, staticRenderFns } from "./gasClamp.vue?vue&type=template&id=4a2d82b6&scoped=true"
import script from "./gasClamp.vue?vue&type=script&lang=js"
export * from "./gasClamp.vue?vue&type=script&lang=js"
import style0 from "./gasClamp.vue?vue&type=style&index=0&id=4a2d82b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d82b6",
  null
  
)

export default component.exports